import queryClient from "single-spa/react-app/query-client";

import { createAdvancedSearchFilteringQueryClient } from "./factory";
import type { IAdvancedSearchFilteringQueryClient } from "./types";

export const advancedSearchFilteringQueryClient: IAdvancedSearchFilteringQueryClient =
    createAdvancedSearchFilteringQueryClient({ queryClient });
